import { apiSlice } from './apiSlice';

export interface InspectedSave {
  id: string; name: string | null; type: string; status: string;
  cursor: { sim_date?: string }; updatedAt: string; lastPlayedAt: string | null;
}
export interface InspectedPlot {
  id: string; name: string | null; svg: string;
  beds: Array<{ id: string; name: string | null; plantings: Array<{
    id: string; crop: string; quantity: number; status: string; fromDate: string; toDate: string | null;
  }> }>;
  structures: Array<{ id: string; name: string | null; subtype: string; activeFrom: string | null; activeTo: string | null }>;
}
const adminSaveViewApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    inspectUserSaves: build.query<InspectedSave[], string>({
      query: (id) => `/admin/users/${encodeURIComponent(id)}/saves`,
      keepUnusedDataFor: 0,
    }),
    inspectUserSave: build.query<{ save: InspectedSave; plots: InspectedPlot[]; readOnly: true }, { userId: string; saveId: string }>({
      query: ({ userId, saveId }) => `/admin/users/${encodeURIComponent(userId)}/saves/${encodeURIComponent(saveId)}/view`,
      keepUnusedDataFor: 0,
    }),
  }),
});
export const { useInspectUserSavesQuery, useInspectUserSaveQuery } = adminSaveViewApi;
